/**
 * Shared floor-plan pin helpers for patrol viewer + 360 link hotspot.
 */

import { normalizeAngleDeg } from "./patrolHotspotProjection";

export function patrolLocationLabel(patrolItem, pinData, index) {
  const raw =
    patrolItem?.editable_location_id ||
    patrolItem?.location_id ||
    pinData?.editable_location_id ||
    pinData?.location_id ||
    patrolItem?.label ||
    pinData?.label;
  if (raw != null && String(raw).trim() !== "") {
    return String(raw).trim();
  }
  return `L${index + 1}`;
}

export function normalizePatrolFloorPins(selectedPatrol) {
  if (!Array.isArray(selectedPatrol)) return [];

  return selectedPatrol
    .map((p, idx) => {
      if (!p?.pin || !Array.isArray(p.pin)) return null;
      const data = p.pin[0];
      if (data?.xPercent == null || data?.yPercent == null) return null;
      return {
        id: p.pin_id,
        xPercent: data.xPercent,
        yPercent: data.yPercent,
        locationLabel: patrolLocationLabel(p, data, idx),
        created_at: p.created_at,
      };
    })
    .filter(Boolean)
    .sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
}

export function patrolVideoIndexForFloorPin(
  selectedPatrol,
  sortedPins,
  floorPinIndex,
) {
  const pinId = sortedPins[floorPinIndex]?.id;
  if (!pinId || !Array.isArray(selectedPatrol)) return -1;
  return selectedPatrol.findIndex((p) => p.pin_id === pinId);
}

/** Same as `PatrolImageViewer.getAngleBetweenPins` — 0° = up on floor, clockwise. */
export function bearingDegBetweenFloorPins(fromPin, toPin) {
  if (!fromPin || !toPin) return 0;
  const dx = toPin.xPercent - fromPin.xPercent;
  const dy = toPin.yPercent - fromPin.yPercent;
  const angleRad = Math.atan2(dy, dx);
  return normalizeAngleDeg((angleRad * 180) / Math.PI + 90);
}

export function bearingDegForPatrolSegment(sortedPins, fromIndex, toIndex) {
  if (!sortedPins?.length) return 0;
  return bearingDegBetweenFloorPins(
    sortedPins[fromIndex],
    sortedPins[toIndex],
  );
}

export function nextPatrolPinIndex(index, count) {
  if (count <= 0) return 0;
  return (index + 1) % count;
}

/** Aligns floor route angle with Three.js equirectangular forward at yaw 0. */
export const PATROL_360_HEADING_OFFSET_DEG = 0;

export function patrolLinkHotspotYawDeg(
  floorRouteAngleDeg,
  yawOffsetDeg = PATROL_360_HEADING_OFFSET_DEG,
) {
  return normalizeAngleDeg(floorRouteAngleDeg + yawOffsetDeg);
}
